<!-- LayoutView.vue -->
<template>
    <div class="max-w-[100rem] mx-auto">
      <Header />
  
      <main>
        <slot></slot>
      </main>
  
      <Footer />
    </div>
  </template>

<script>
import Header from '../headers/HeaderContent.vue'
import Footer from '../footers/FooterContent.vue'

export default {
    components: {
        Header,
        Footer
    }
}
</script>